import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeDocument, EmployeeDocumentCreate, EmployeeDocumentFilter } from '../data/employeeDocument';

export function createEmployeeDocumentService(client: AxiosInstance) {
  return createCrudService<EmployeeDocument, EmployeeDocumentCreate, EmployeeDocumentFilter>(
    client,
    '/hrm/EmployeeDocument',
    'id',
  );
}

export type EmployeeDocumentService = CrudService<EmployeeDocument, EmployeeDocumentCreate, EmployeeDocumentFilter>;
